import { api } from "@/frontend/services/api";
import type {
  CountryResponseDTO,
  CountriesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
  CreateCountryRequestDTO,
  UpdateCountryRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/countries/private";

export const countryService = {
  getPaginate: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<CountriesPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id?: string) =>
    api.get<ApiResponse<CountryResponseDTO>>(`${BASE_URL}/id/${id}`),
  getByCode: (code?: string) =>
    api.get<ApiResponse<CountryResponseDTO>>(`${BASE_URL}/code/${code}`),
  create: (data: CreateCountryRequestDTO) =>
    api.post<ApiResponse<CountryResponseDTO>>(BASE_URL, data),
  update: (code: string, data: UpdateCountryRequestDTO) =>
    api.put<ApiResponse<CountryResponseDTO>>(`${BASE_URL}/${code}`, data),
  delete: (code: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${code}`),
};
